export default "__VITE_ASSET__D_uGH6v0__"